export default "__VITE_ASSET__CMrOGfg3__"